var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "ax-navbar__nav", attrs: { id: "user-menu" } },
    [
      _c("div", { staticClass: "ax-navbar__icon-link" }, [
        _vm.clientViewUrl
          ? _c(
              "a",
              {
                staticClass: "ax-navbar__action-icon",
                attrs: {
                  "aria-label": "client view",
                  href: _vm.clientViewUrl,
                  target: "_blank"
                }
              },
              [_c("cv-link", { staticClass: "ax-navbar-user__svg" })],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ax-navbar__icon-link",
          attrs: { id: "help-menu-container" }
        },
        [
          _c(
            "button",
            {
              staticClass: "ax-navbar__action-icon",
              class: this.menuState.helpIsOpen
                ? "ax-navbar__action-icon--active"
                : "",
              attrs: { id: "help-menu-btn", "aria-label": "help menu" },
              on: {
                click: function($event) {
                  return _vm.toggleMenu("help")
                },
                keyup: function($event) {
                  return _vm.toggleMenu("help")
                }
              }
            },
            [_c("question-mark", { staticClass: "ax-navbar-user__svg" })],
            1
          ),
          _vm._v(" "),
          this.menuState.helpIsOpen
            ? _c(
                "div",
                {
                  staticClass:
                    "\n                ax-navbar__second-level-container\n                ax-navbar__second-level-container--has-link-connector\n                ax-navbar__second-level-container--orient-right\n            "
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass: "ax-navbar__second-level-column",
                      attrs: { id: "help-menu-list" }
                    },
                    _vm._l(_vm.helpMenu, function(item) {
                      return _c(
                        "li",
                        {
                          key: item.caption,
                          staticClass: "ax-navbar__sub-level-item-row"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "ax-navbar__sub-level-item-col" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "ax-navbar__sub-level-menu-link",
                                  attrs: {
                                    href: item.path,
                                    target: item.target
                                  },
                                  on: { click: _vm.closeMenu }
                                },
                                [_vm._v(_vm._s(item.caption))]
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ax-navbar__icon-link",
          attrs: { id: "user-menu-container" }
        },
        [
          _c(
            "button",
            {
              staticClass: "ax-navbar__action-icon",
              class: this.menuState.userIsOpen
                ? "ax-navbar__action-icon--active"
                : "",
              attrs: { id: "user-menu-btn", "aria-label": "user menu" },
              on: {
                click: function($event) {
                  return _vm.toggleMenu("user")
                },
                keyup: function($event) {
                  return _vm.toggleMenu("user")
                }
              }
            },
            [_c("user", { staticClass: "ax-navbar-user__svg" })],
            1
          ),
          _vm._v(" "),
          this.menuState.userIsOpen
            ? _c(
                "div",
                {
                  staticClass:
                    "\n                ax-navbar__second-level-container\n                ax-navbar__second-level-container--has-link-connector\n                ax-navbar__second-level-container--orient-right\n            "
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass: "ax-navbar__second-level-column",
                      attrs: { id: "user-menu-list" }
                    },
                    _vm._l(_vm.userMenu, function(item, index) {
                      return _c(
                        "li",
                        {
                          key: item.caption + index,
                          staticClass: "ax-navbar__sub-level-item-row"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "ax-navbar__sub-level-item-col" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "ax-navbar__sub-level-menu-link",
                                  attrs: {
                                    href: item.path,
                                    target: item.target
                                  },
                                  on: {
                                    click: function($event) {
                                      return this.onClick(item.caption)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.caption))]
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }